import React from 'react';

import { __t, PAYMENT_PROVIDERS } from '@mssgme/shared';
import { LandingsPropTypes } from '@mssgme/ui';
import { useModalThemes, usePaymentConfigs } from '../../hooks';
import { ThemedButton } from '../../UI';

export const PayButton = ({ provider, ...props }) => {
    const { isSingular } = usePaymentConfigs();
    const { contentStyle } = useModalThemes();
    const label = PAYMENT_PROVIDERS[provider]?.label || provider;
    const Icon = PAYMENT_PROVIDERS[provider]?.icon;

    return (
        <ThemedButton
            fullWidth
            tag="button"
            type="submit"
            beforeIcon={Icon && <Icon size={24} />}
            theme={contentStyle}
            contentAlignLeft
            {...props}
        >
            {__t(isSingular ? 'pay' : 'payWith', { provider: label })}
        </ThemedButton>
    );
};

PayButton.propTypes = {
    provider: LandingsPropTypes.paymentMethod,
};
